import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

export default function TopRanking({ movies }: { movies: Movie[] }) {
  return (
    <div className="bg-background-100 border border-background-300/50 rounded-lg overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 bg-accent-800 border-b border-background-300/50">
        <i className="ri-fire-fill text-primary-500 text-lg"></i>
        <h3 className="text-sm font-bold text-foreground-950">近期热门榜单</h3>
      </div>
      <ul className="divide-y divide-background-300/40">
        {movies.map((movie, idx) => (
          <li key={movie.id}>
            <Link to={`/movie/${movie.id}`} className="group flex items-center gap-3 px-4 py-3 hover:bg-background-200/50 transition-colors">
              <span className={`font-label text-2xl w-6 text-center ${idx < 3 ? 'text-primary-500' : 'text-foreground-500'}`}>
                {idx + 1}
              </span>
              <div className="w-11 h-14 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} - 热门推荐`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-400 transition-colors">
                  {movie.title}
                </p>
                <p className="text-xs text-foreground-600 truncate mt-0.5">
                  {movie.category} · {movie.year}
                </p>
              </div>
              <span className="text-xs text-primary-400 font-semibold shrink-0">{movie.rating.toFixed(1)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}